import { assets } from './assets';
import { components } from './components';
import { fonts } from './fonts';
import { metadata } from './metadata';
import { defaultActivityThemeStyles } from './themes';
import { UIModuleType } from '../../types';

export const uiModule: UIModuleType = {
  defaultActivityThemeStyles,
  metadata,
  assets,
  fonts,
  components
};
